import {initialState, setUserModules} from '@/models/chart';
// import {chartTypes} from '@/components/charts';

// import SockJS from "sockjs-client";
// import Stomp from "webstomp-client";

const _initialState = initialState(); // can load from localStorage

import JwtService from "@/services/jwt.service";
const user = setUserModules(JwtService.getUser());

// console.log("user 100", JwtService.getUser());
// console.log("user 100", user);



// let stompClient = null;
// const connect = () => {

//   let sockJS = new SockJS("http://localhost:8090/ws");
//   stompClient = Stomp.over(sockJS);
//   stompClient.connect({}, onConnected, onError);
// };

// const onConnected = () => {
//   console.log("is connected");

//   stompClient.subscribe(
//     "/user/" + 51 + "/notifications",
//     onMessageReceived
//   );
// };

// const onError = (error) => {
//   console.log("errored", error);

// };


// const onMessageReceived = (payload) => {
//   console.log("message", payload);
//   let body = JSON.parse(payload.body);
//   alert(body.message);

//   // stompClient.subscribe(
//   //   "/user/" + currentUser.id + "/queue/messages",
//   //   onMessageReceived
//   // );
// };

// connect();


// const dataSource = createDataSource();
export default {
  ..._initialState,
  ...{fulscreen: true, dialogTitle: ""},
  ...{user},
  ...{loadTime: new Date().toISOString()}
}
